export const INITIAL_USERS_SEARCH_PARAMS = {
  id: '',
  first_name: '',
  last_name: '',
  email: '',
  employee_id: '',
  page: 1,
  limit: 15,
  order_by: 'id',
  sort_method: 'DESC',
  status: 1,
}

export const INITIAL_USER = {
  address1: null,
  address2: null,
  cell_phone: null,
  city: null,
  aclients: [],
  country_id: 0,
  department_id: null,
  email: null,
  employee: '',
  first_name: null,
  home_phone: null,
  job_title: null,
  language_id: 0,
  last_name: null,
  notes: null,
  notifying: 0,
  office_extension: null,
  office_phone: null,
  province_id: 0,
  roles: [],
  status: 1,
  warehouse_id: null,
  dashboard: false,
  scanner_gun: false,
  prox: false,
  portal: false,
  production_user: false,
  order_error: 0,
  item_error: 0,
  low_level: 0,
  qa_release: 0,
  notify_shipment: 0,
  notify_shipment_costco: 0,
  notify_backorder: 0,
  notify_legacy_discrepancy: 0,
  notify_order_threshold: 0,
  short_date: 0,
  po_error: 0,
}
